import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EditorialPage",
    data() {
        let ss = new MainService();
        return {
            msg: "EditorialPage",
            ss: ss,
            ajax: {
                "url": ss.indexEditorial(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'Editorial', name: 'Editorial', title: 'Editorial' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            editoriales: [],
            editorial: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newEditorial() {
            this.editorial = {};
            this.$refs['frm-editorial'].show();
        },
        showEditorial(id) {
            this.isLoading=true;
            this.ss.showEditorial(id).then(
                (result) => {
                    let response = result.data;
                    this.editorial = response.data;
                    this.$refs['view-editorial'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editEditorial() {
            this.$refs['frm-editorial'].show();
            this.$refs['view-editorial'].hide();
        },
        cancelEditorial() {
            if (this.editorial.id) {
                this.$refs['view-editorial'].show();
            }
            this.$refs['frm-editorial'].hide();
        },
        saveEditorial() {
            this.ss.storeEditorial(this.editorial).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-editorial'].hide();
                    this.$refs['datatable-editorial'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEditorial() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyEditorial(this.editorial)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-editorial'].hide();
                                this.$refs['datatable-editorial'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Editorial').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showEditorial(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
